import clsx from 'clsx'
import { atom, useAtom } from 'jotai'
import { memo } from 'react'
import { SectionTitleTabs } from 'styles'

export enum RecentTradesTabType {
  MarketTrades,
  MyTrades,
}

export const recentTradesTabsAtom = atom<RecentTradesTabType>(
  RecentTradesTabType.MarketTrades,
)

export const RecentTradesTabs = memo(() => {
  const [tab, setTab] = useAtom(recentTradesTabsAtom)

  return (
    <SectionTitleTabs>
      <span
        className={clsx({ active: tab === RecentTradesTabType.MarketTrades })}
        onClick={() => setTab(RecentTradesTabType.MarketTrades)}
      >
        Market Trades
      </span>
      {/* <span
        className={clsx({ active: tab === RecentTradesTabType.MyTrades })}
        onClick={() => setTab(RecentTradesTabType.MyTrades)}
      >
        My Trades
      </span> */}
    </SectionTitleTabs>
  )
})
